import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'supply-monitoring-stats-page',
  templateUrl: './supply-monitoring-stats-page.component.html',
  styleUrls: ['./supply-monitoring-stats-page.component.scss'],
})
export class SupplyMonitoringStatsPageComponent {
  constructor() {}
}
